import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-about-info-modal',
    templateUrl: './about-info-modal.component.html',
    styleUrls: ['./about-info-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AboutInfoModalComponent {

    @Input() header = 'About';
    public appName = navigator.appCodeName;
    public appVersion = navigator.appVersion.substr(0, navigator.appVersion.indexOf(' '));
    public userAgent = navigator.userAgent;
    public platform = navigator.platform;
    public language = navigator.language;
    public onLine = navigator.onLine;
    public cookieEnabled = navigator.cookieEnabled;
    public screenSize = window.screen.width + ' x ' + window.screen.height;
    public pixelRatio = window.devicePixelRatio;
    public browserName = this.getBrowserName();
    public browserVersionTrue = this.getBrowserVersion();
    public browserVersion = this.getBrowserVersion().substring(0, this.getBrowserVersion().indexOf('.'));
    public osName = this.getOSName();
    public deviceName = this.getDeviceName();
    public maxTouchPoints = navigator.maxTouchPoints;

    // TODO => Need to remove save button

    private getBrowserName(): string {
        const agent = window.navigator.userAgent.toLowerCase();
        switch (true) {
            case agent.indexOf('edge') > -1:
                return 'Edge';
            case agent.indexOf('opr') > -1 && !!(<any>window).opr:
                return 'Opera';
            case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
                return 'Chrome';
            case agent.indexOf('trident') > -1:
                return 'IE';
            case agent.indexOf('firefox') > -1:
                return 'Firefox';
            case agent.indexOf('safari') > -1:
                return 'Safari';
            default:
                return 'Other';
        }
    }


    private getBrowserVersion(): string {
        const agent = window.navigator.userAgent.toLowerCase();
        switch (true) {
            case agent.indexOf('edge') > -1:
                return agent.substring(agent.indexOf('edge') + 5);
            case agent.indexOf('opr') > -1 && !!(<any>window).opr:
                return agent.substring(agent.indexOf('opr') + 4);
            case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
                const chromeTempVar = agent.substring(agent.indexOf('chrome') + 7);
                return chromeTempVar.substring(0, chromeTempVar.indexOf('safari'));
            case agent.indexOf('firefox') > -1:
                return agent.substring(agent.indexOf('firefox') + 8);
            case agent.indexOf('safari') > -1:
                const safariTempVar = agent.substring(agent.indexOf('version') + 8);
                return safariTempVar.substring(0, safariTempVar.indexOf('safari'));
            default:
                return '';
        }
    }

    private getOSName(): string {
        const plateform = window.navigator.platform;
        if (plateform.indexOf('Win') > -1) {
            return 'windowsOS';
        }
        if (plateform.indexOf('Mac') > -1) {
            return 'macOS';
        }
        if (plateform.indexOf('X11') > -1) {
            return 'unixOS';
        }
        if (plateform.indexOf('Linux') > -1) {
            return 'linuxOS';
        }
        return 'Other';
    }

    private getDeviceName(): string {
        const tempDeviceName = (window.navigator.userAgent.match(/Android/i) ||
            window.navigator.userAgent.match(/BlackBerry/i) ||
            window.navigator.userAgent.match(/iPhone|iPad|iPod/i) ||
            window.navigator.userAgent.match(/Opera Mini/i) ||
            window.navigator.userAgent.match(/IEMobile/i));

        return tempDeviceName ? tempDeviceName.toString() : 'Desktop';
    }
}
